module.exports = __webpack_public_path__ + "img/slide3.2dbaaf87.png";